module.exports = __webpack_public_path__ + "media/img/country_flags-3f9d4c2eaac6057ce601cdedaf27cb10.png";